import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { END_POINTS_URL } from 'src/app/shared/constants/end-points-url';
import {
  BadgeCelebrationStateModel,
  BadgeHistoryEntryModel,
  BadgeProfileSummaryModel,
  BadgeWelcomeStateModel,
  RecentAchievementModel,
  UserBadgesModel,
} from './achievements.model';

@Injectable({ providedIn: 'root' })
export class AchievementsService {
  /** Fires when the current user's badges changed (featured selection saved, new badge celebrated). */
  readonly badgesChanged$ = new Subject<void>();

  constructor(private http: HttpClient) {}

  getUserBadges(userName: string): Observable<UserBadgesModel> {
    const params = new HttpParams().set('userName', userName);
    return this.http.get<UserBadgesModel>(`${END_POINTS_URL.BADGE_API.BADGES}/user-badges`, {
      params,
    });
  }

  getRecentAchievements(userName: string, count = 3): Observable<RecentAchievementModel[]> {
    const params = new HttpParams().set('userName', userName).set('count', String(count));
    return this.http.get<RecentAchievementModel[]>(
      `${END_POINTS_URL.BADGE_API.BADGES}/recent-achievements`,
      { params }
    );
  }

  getProfileSummary(userName: string): Observable<BadgeProfileSummaryModel> {
    const params = new HttpParams().set('userName', userName);
    return this.http.get<BadgeProfileSummaryModel>(
      `${END_POINTS_URL.BADGE_API.BADGES}/profile-summary`,
      { params }
    );
  }

  setFeatured(codes: string[]): Observable<void> {
    return this.http.put<void>(`${END_POINTS_URL.BADGE_API.BADGES}/featured`, { codes });
  }

  getBadgeHistory(userName: string, code: string): Observable<BadgeHistoryEntryModel[]> {
    const params = new HttpParams().set('userName', userName).set('code', code);
    return this.http.get<BadgeHistoryEntryModel[]>(`${END_POINTS_URL.BADGE_API.BADGES}/history`, {
      params,
    });
  }

  getWelcomeState(): Observable<BadgeWelcomeStateModel> {
    return this.http.get<BadgeWelcomeStateModel>(`${END_POINTS_URL.BADGE_API.BADGES}/welcome`);
  }

  dismissWelcome(): Observable<void> {
    return this.http.post<void>(`${END_POINTS_URL.BADGE_API.BADGES}/welcome/dismiss`, null);
  }

  getCelebrationState(): Observable<BadgeCelebrationStateModel> {
    return this.http.get<BadgeCelebrationStateModel>(`${END_POINTS_URL.BADGE_API.BADGES}/celebration`);
  }

  dismissCelebration(asOf: string): Observable<void> {
    return this.http.post<void>(`${END_POINTS_URL.BADGE_API.BADGES}/celebration/dismiss`, { asOf });
  }
}
